import React from "react";
import "./Footer.css";
import animationData from "../../Components/Home/Sector_We_Serve/LOTTIE/SECTOR/chat_bot.json";
import busAnimationData1 from "../../Components/Home/Sector_We_Serve/LOTTIE/SECTOR/Wave.json";
import { Link } from "react-router-dom";
import { Col, Container, Row } from "react-bootstrap";
import {
  faBagShopping,
  faEnvelopeOpen,
  faHand,
  faLocationDot,
  faPhone,
  faShoppingCart,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faEnvelope,
  faHeart,
  faUser,
} from "@fortawesome/free-regular-svg-icons";
import {
  faFacebookF,
  faInstagram,
  faLinkedinIn,
  faThreads,
  faWhatsapp,
  faYoutube,
} from "@fortawesome/free-brands-svg-icons";
import Lottie_Holder from "../Lottie_Holder/Lottie_Holder";

const Footer = () => {
  const lnks = [
    {
      name: "Home",
      BaseLink: "/",
    },
    {
      name: "About Us",
      BaseLink: "/about-us",
    },
    {
      name: "Services",
      BaseLink: "/services",
    },
    {
      name: "Contact Us",
      BaseLink: "/contact-us",
    },
    {
      name: "Careers",
      BaseLink: "/career",
    },
    {
      name: "Terms & Conditions",
      BaseLink: "/terms-condition",
    },
    {
      name: "Privacy Policy",
      BaseLink: "/privacy-policy",
    },
  ];
  return (
    <>
      <section className="main_footer_holder">
        <div className="bg_text_holder">
          <h1>Where Ideas Take Flight</h1>
        </div>

        <div className="footer_div">
          <Container>
            <Row>
              <Col
                xxl={10}
                xl={10}
                lg={12}
                md={12}
                sm={12}
                xs={12}
                className="mx-auto"
              >
                <div className="footermain_div">
                  <div className="footer_miidle">
                    <Row>
                      <Col xxl={12}>
                        <div className="all_icon ">
                          {/* <FontAwesomeIcon icon={faFacebookF} className="cart-logo" /> */}
                          {/* <FontAwesomeIcon icon={faFacebook} /> */}
                          <Link
                            to={
                              "https://www.facebook.com/profile.php?id=61567246887800"
                            }
                            target="_blank"
                          >
                            <div className="headericn_div">
                              <FontAwesomeIcon
                                className="cart_logo"
                                icon={faFacebookF}
                              />
                            </div>
                          </Link>

                          <Link
                            to={
                              "https://www.instagram.com/reachoutmediatech/?hl=en"
                            }
                            target="_blank"
                          >
                            <div className="headericn_div">
                              {/* <FontAwesomeIcon
                            icon={faHeart}
                            className="cart_logo"
                          /> */}
                              <FontAwesomeIcon
                                icon={faInstagram}
                                className="cart_logo"
                              />
                            </div>
                          </Link>
                          <Link
                            to={"https://www.linkedin.com/company/104845041/"}
                            target="_blank"
                          >
                            <div className="headericn_div">
                              {/* <FontAwesomeIcon
                            icon={faUser}
                            className="cart_logo"
                          /> */}
                              <FontAwesomeIcon
                                icon={faLinkedinIn}
                                className="cart_logo"
                              />
                            </div>
                          </Link>
                          <Link
                            to={"https://www.youtube.com/@ReachOutMediaTech"}
                            target="_blank"
                          >
                            <div className="headericn_div">
                              <FontAwesomeIcon
                                icon={faYoutube}
                                className="cart_logo"
                              />
                            </div>
                          </Link>
                          {/* <Link
                          to={"https://www.threads.net/@reachoutmediatech"}
                          target="_blank"
                        >
                          <div className="headericn_div">
                            <FontAwesomeIcon
                              icon={faThreads}
                              className="cart_logo"
                            />
                          </div>
                        </Link> */}
                        </div>
                      </Col>
                    </Row>
                  </div>
                  <div className="footer_top">
                    <div className="d-flex justify-content-around flex-wrap">
                      {lnks.map((text, index) => (
                        <div className="top_div_footer  ">
                          <Link to={text.BaseLink}>
                            <p className="top_text px-2">{text.name}</p>
                          </Link>
                        </div>
                      ))}
                    </div>
                  </div>

                  <div className="footer_miidle">
                    <div className="top_div_footer">
                      <Row>
                        <Col xxl={4} xl={4} lg={4} md={12} sm={12} xs={12}>
                          <div className="addres_div padding_div">
                            <div>
                              <p className="top_text">
                                <div className="headericn_div ms-0 me-2">
                                  <FontAwesomeIcon
                                    className="cart_logo "
                                    icon={faLocationDot}
                                  />
                                </div>
                                6th Floor, Gandharv Empire, Raskar Chowk,
                                Magarpatta, Pune, Maharashtra, 411036
                              </p>
                            </div>
                          </div>
                        </Col>
                        <Col xxl={4} xl={4} lg={4} md={6} sm={6} xs={12}>
                          <div className="contact_div padding_div">
                            <div>
                              <p className="top_text">
                                <div className="headericn_div ms-0  me-2">
                                  <FontAwesomeIcon
                                    className="cart_logo"
                                    icon={faEnvelope}
                                  />
                                </div>
                                info@reachoutmediatech.com
                              </p>

                              <p className="top_text mb-0">
                                <div className="headericn_div ms-0  me-2">
                                  <FontAwesomeIcon
                                    className="cart_logo"
                                    icon={faPhone}
                                  />
                                </div>
                                Toll-Free: 1800-268-2424
                              </p>
                            </div>
                          </div>
                        </Col>

                        <Col xxl={4} xl={4} lg={4} md={6} sm={6} xs={12}>
                          <div className="addres_div padding_div">
                            <div>
                              <p className="top_text">
                                <div className="headericn_div ms-0 me-2">
                                  <FontAwesomeIcon
                                    className="cart_logo "
                                    icon={faBagShopping}
                                  />
                                </div>
                                Working Days: Monday to Saturday <br />
                                Working Hours: 10 AM To 7 PM
                              </p>
                            </div>
                          </div>
                        </Col>
                      </Row>
                    </div>
                  </div>

                  <p className="bottom_footer_text">
                    © 2025 ReachOut Media Tech Pvt. Ltd. All Rights Reserved.
                    Developed by <Link  target="_blank"  to="https://profcymaglobal.com">Profcyma</Link>
                  </p>
                </div>
              </Col>
            </Row>
          </Container>
        </div>
      </section>
      <Link to={"https://wa.me/918484024823"} target="_blank">
        <div className="chat_bot_holder chat_bot">
          <Lottie_Holder animationData={animationData} />
          <div className="icon-text-holder">
            <div className="icon-holder ">
              <FontAwesomeIcon className="icon" icon={faPhone} />
            </div>
            <p>Toll-Free: 1800-268-2424</p>
          </div>
        </div>
      </Link>

      <Link to={"/services-inner/1"}>
        <div className="bus_lottie_holder chat_bot_holder bounce2">
         
          <Lottie_Holder animationData={busAnimationData1} />
          <video
            className="vdo_wala_bus_logo_vdo"
            src={
              process.env.PUBLIC_URL +
              "/Assets/Vedio/Vdo_Wala_bus_vdo/vdo_wala_bus_logo_vdo.mp4"
            }
            autoPlay
            loop
            muted
          />
        </div>
      </Link>
    </>
  );
};

export default Footer;
